import { render, staticRenderFns } from "./ManualText.vue?vue&type=template&id=6fd7373e&"
import script from "./ManualText.vue?vue&type=script&lang=js&"
export * from "./ManualText.vue?vue&type=script&lang=js&"
import style0 from "./ManualText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports